import axios from 'axios'
import api from 'service/api'
import { getBaseURL } from 'service/env'
import * as service from 'service'
import changeCaseKeys from 'helpers/changeCase/keys'

const dponetAPI = api.create('dponet')

const dponetFormDataAPI = (() => {
  const instance = axios.create({ baseURL: getBaseURL('dponet') })

  instance.interceptors.request.use((reqConfig) => {
    const authToken = service.dponet.auth.getToken()
    reqConfig.headers = reqConfig.headers || {}
    reqConfig.headers.Authorization = authToken ? `${authToken}` : undefined
    reqConfig.headers.crossDomain = true
    return reqConfig
  })

  instance.interceptors.response.use(
    (resp) => changeCaseKeys.camelCase(resp),
    (error) => Promise.reject(changeCaseKeys.camelCase(error)),
  )

  return instance
})()

const get = async (params) =>
  await dponetAPI.get('/phishing_campaigns', { params })

const dashboard = async (params) =>
  await dponetAPI.get('/phishing_campaigns/dashboard', { params })

const show = async (phishingCampaignId) =>
  await dponetAPI.get(`/phishing_campaigns/${phishingCampaignId}`)

const create = async (data) => await dponetAPI.post('/phishing_campaigns', data)

const configStep = async (phishingCampaignId, data) => {
  return await dponetAPI.patch(
    `/phishing_campaigns/${phishingCampaignId}/config_step`,
    data,
  )
}

const participantsStep = async (phishingCampaignId, data) => {
  return await dponetAPI.patch(
    `/phishing_campaigns/${phishingCampaignId}/participants_step`,
    data,
  )
}

const templatesStep = async (phishingCampaignId, data) => {
  return await dponetAPI.patch(
    `/phishing_campaigns/${phishingCampaignId}/templates_step`,
    data,
  )
}

const scheduleStep = async (phishingCampaignId, data) => {
  return await dponetAPI.patch(
    `/phishing_campaigns/${phishingCampaignId}/schedule_step`,
    data,
  )
}

const confirmStep = async (phishingCampaignId) =>
  await dponetAPI.post(`/phishing_campaigns/${phishingCampaignId}/confirm_step`)

const cancel = async (phishingCampaignId) =>
  await dponetAPI.post(`/phishing_campaigns/${phishingCampaignId}/cancel`)

const finalize = async (phishingCampaignId) =>
  await dponetAPI.post(`/phishing_campaigns/${phishingCampaignId}/finalize`)

const history = async (phishingCampaignId, params) => {
  return await dponetAPI.get(
    `/phishing_campaigns/${phishingCampaignId}/history`,
    { params },
  )
}

const participantStates = async (phishingCampaignId, params) => {
  return await dponetAPI.get(
    `/phishing_campaigns/${phishingCampaignId}/participant_states`,
    { params },
  )
}

const dailyStats = async (phishingCampaignId) => {
  return await dponetAPI.get(
    `/phishing_campaigns/${phishingCampaignId}/daily_stats`,
  )
}

const importParticipants = async (phishingCampaignId, file) =>
  await dponetFormDataAPI.postForm(
    `/phishing_campaigns/${phishingCampaignId}/import_participants`,
    { file },
  )

const destroy = async (phishingCampaignId) => {
  return await dponetAPI.delete(`/phishing_campaigns/${phishingCampaignId}`)
}

const generateReport = async (data) =>
  await dponetAPI.post('/phishing_campaigns/report', data)

const phishingCampaigns = {
  get,
  dashboard,
  show,
  create,
  configStep,
  participantsStep,
  templatesStep,
  scheduleStep,
  confirmStep,
  cancel,
  finalize,
  history,
  participantStates,
  dailyStats,
  importParticipants,
  destroy,
  generateReport,
}

export default phishingCampaigns
